





















import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {translate} from "@/services/translation/translation";
import './_checkbox-group.less';
import $ from 'jquery';
import {goToTop} from "@/services/position/position";
import {string} from "prop-types";

@Component({})

export default class checkboxGroup extends Vue {
    @Prop() model;
    @Prop() refresh;

    private data: any = {
        model: {}
    };

    mounted(){
        goToTop('', this.model.componentSetting.id);
    }
    updated() {
        let self = this;
        $.each(this.model.componentSetting.items, function (index, item) {
            if (item.id == self.data.model && !item.isEnabled) {
                self.data.model = "";
            }
        })
    }

    trans(key) {
        return translate(key);
    }



    @Watch("data.model", {immediate: true, deep: true})
    changeComponentSettingModel(newValue) {
        let componentValue :any = {};
        let self = this;

        let values =[];
        
        $.each(this.data.model, function (index, m) {
            if(m){
            let o = {
                id: index,
                value: m
            }
                values.push(o)
            }
        });





        $.each(this.model.componentSetting.items, function (index, element) {
            if(values.length>0 && values[0].id == element.id){
                componentValue.id = self.model.componentSetting.id;
                componentValue.name = self.model.componentSetting.name;
                componentValue.value = values;
                componentValue.values = values;
                componentValue.value_id = element.id;
                componentValue.next_question = element.next_question;
                componentValue.isEnableNext = self.model.isEnableNext;
                if(typeof element.alternatenext != "undefined"){
                    componentValue.alternatenext = element.alternatenext;
                }
            }
        });
        this.onSelectedQuestionValue(componentValue);
    }


    @Watch("model", {immediate: true, deep: true})
    changeModel(newVal, oldVal){
        if(this.data.model != {} && (this.model.value_id == "" || this.model.value == "" ) ){
            this.changeComponentSettingModel(this.data.model);
        }
    }


    @Emit("selectedQuestionValue")
    onSelectedQuestionValue(value) {
    }

}

